import { useEffect } from "react";

import styled from "styled-components";

import Sentry from "@similarweb/sentry-logger";
import { Button, EmptyState } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { proNavigator } from "single-spa/react-app/ProNavigator";

const EmptyStateWrapper = styled.div`
    padding: 16px;
`;

const StyledButton = styled(Button)`
    margin-top: 16px;
`;

const createButtonWrapper = (resetErrorBoundary?: () => void) =>
    function () {
        return (
            <StyledButton
                onClick={() => {
                    resetErrorBoundary?.();
                    location.reload();
                }}
            >
                {translate("error.boundary.cta.button.text")}
            </StyledButton>
        );
    };

export const WidgetErrorFallback = ({
    resetErrorBoundary,
    error,
}: {
    resetErrorBoundary?: () => void;
    error: Error;
}) => {
    useEffect(() => {
        const pageId = proNavigator.getCurrentPageId();
        Sentry.errorTracker({
            message: `Widget error boundary in: section: ${pageId?.section} - subSection: ${pageId?.subSection} - subSubSection: ${pageId?.subSubSection} - pageId: ${pageId?.pageId}`,
            e: error,
            level: "fatal",
        });
    }, [error]);

    const ButtonWrapper = createButtonWrapper(resetErrorBoundary);

    return (
        <EmptyStateWrapper>
            <EmptyState
                title={translate("error.boundary.title")}
                subtitle={translate("error.boundary.subtitle")}
                CtaButtons={ButtonWrapper}
                iconName={"no-data-tree"}
            />
        </EmptyStateWrapper>
    );
};
